export default "__VITE_ASSET__M2MH6kIB__"